import { useMerchant } from '../contexts/MerchantContext'
import { useUser } from '../contexts/UserContext'
import { apiURI } from '../utils/constants'
import { ActivityLogPayloadType, Metadata } from '../types/activityLogTypes'

export enum EntityName {
  ORDERS = 'Orders Tab',
  ORDER_CONFIRMATION = 'Order Confirmation Tab',
  OVERVIEW = 'Overview Tab',
  DISCOUNTS = 'Discounts Tab',
  AUTOMATIONS = 'Automations Tab',
  ABANDONED_CHECKOUTS = 'Abandoned Checkouts Tab',
  UPSELL = 'Upsell Tab',
  PAYMENT_OFFERS = 'Payment Offers Tab',
  REWARDS = 'Rewards Tab',
  SHIPPING_ZONES = 'Shipping Zones Tab',
  RTO_SUITE = 'RTO Suite Tab',
  CUSTOMISE_UI = 'Customise UI Tab',
  CART = 'Cart Tab',
  CART_WIDGET_TAB = 'Cart Widget Tab',
  CART_CORE_TAB = 'Cart Core Setup Tab',
  PDP = 'PDP Tab',
  SETTINGS = 'Settings Tab',
  SHOPFLO_APPS = 'Shopflo Apps',
  ONE_CLICK_ADD_ON = 'One Click Add On Tab',
  SEGMENTS = 'Segments Tab'
}

export const useActivityLogs = () => {
  const {
    getters: { merchant }
  } = useMerchant()
  const { user } = useUser()

  const sendActivityLogBody = {
    merchant_id: merchant?.accountId,
    store_user_id: user?.id,
    user_email: user?.email,
    user_name: `${user?.firstName} ${user?.lastName}` || user?.email,
    designation: user?.role,
    timestamp: new Date().getTime(),
    roles: user?.roles,
    is_super_admin: user?.isSuperAdmin
  }
  const generateActivityLogBody = (payload: {
    entityName: EntityName
    entityId?: string
    actionName: string
    metadata?: Metadata
  }) => {
    return {
      ...sendActivityLogBody,
      entity_name: payload.entityName,
      entity_id: payload.entityId,
      action_name: payload.actionName,
      metadata: Boolean(payload.metadata) ? payload.metadata : {}
    }
  }

  const sendActivityLog = async (payload: ActivityLogPayloadType) => {
    const body = generateActivityLogBody(payload)
    const url = `${apiURI.ACTIVITY_LOG_SEND}/pulse`
    try {
      // const res = await postRequest('/pulse', apiURI.ACTIVITY_LOG_SEND, body)
      navigator.sendBeacon(url, JSON.stringify(body))
    } catch (err) {
      // todo: handle error to store these logs in localstorage and retrieve thes e
      // need a new endpoint to push these logs in bulk
      // const activityLogs = localStorage.getItem('activityLogs') || '[]'
      // localStorage.setItem('activityLogs', JSON.stringify([...JSON.parse(activityLogs), body]))
      console.error(err)
    }
  }

  return {
    sendActivityLog
  }
}
